import { render, staticRenderFns } from "./Invalid.vue?vue&type=template&id=5cbce96f&scoped=true"
import script from "./Invalid.vue?vue&type=script&lang=js"
export * from "./Invalid.vue?vue&type=script&lang=js"
import style0 from "./Invalid.vue?vue&type=style&index=0&id=5cbce96f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbce96f",
  null
  
)

export default component.exports